import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAmountIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 20,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.583 4.19 11.033.196 9.865 1.819l3.033 2.183h-7.8l3.033-2.183L6.962.196 1.412 4.19l-.415.3v.512l.002 10v1h16V4.489l-.416-.3zM2.997 6.002h12.002v8h-12l-.002-8zM7 10h4V8H7v2z",
		fill: "#111"
	})
});
export default SvgAmountIcon;
